import {Injectable} from '@angular/core';
import {ConnectorMessage} from './connector-message';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObjectExtractingServiceService {

  private message$: BehaviorSubject<ConnectorMessage> = new BehaviorSubject<ConnectorMessage>(null);

  constructor() {
  }

  public handleAction(messageObject: ConnectorMessage): void {
    this.message$.next(messageObject);
  }

  public getMessageBehaviorSubject() {
    return this.message$.asObservable();
  }
}
